import { render, staticRenderFns } from "./BaseCollapsible.vue?vue&type=template&id=7d2f1c16&scoped=true&"
import script from "./BaseCollapsible.vue?vue&type=script&lang=js&"
export * from "./BaseCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./BaseCollapsible.vue?vue&type=style&index=0&id=7d2f1c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f1c16",
  null
  
)

export default component.exports